// removed by extract-text-webpack-plugin
module.exports = {"wasabi-toolbar":"wasabi-toolbar"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Buttons/Toolbar.scss
// module id = 169
// module chunks = 0